import { translate } from '@cashfree-intl/coherent'; /* eslint-disable */
import * as Yup from 'yup';

const kycFormV2ValidationSchema = () => {
  return Yup.object({
    PAN: Yup.string()
      .length(10, `${translate('incorrect_pan_please_enter_a_valid_pan')}`)
      .matches(
        /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
        `${translate('incorrect_pan_please_enter_a_valid_pan')}`,
      )
      .trim(),

    UIDAI: Yup.string()
      .length(
        12,
        `${translate('incorrect_aadhaar_please_enter_a_valid_aadhaar')}`,
      )
      .matches(
        /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
        `${translate('incorrect_aadhaar_please_enter_a_valid_aadhaar')}`,
      )
      .trim(),

    GSTIN: Yup.string()
      .length(
        15,
        `${translate('invalid_gst_number_please_enter_a_valid_gst_number')}`,
      )
      .matches(
        /^[0-9]{2}[A-Z|a-z|0-9]{13}$/,
        `${translate('invalid_gst_please_enter_a_valid_gst')}`,
      )
      .trim(),

    CIN: Yup.string()
      .length(21, `${translate('invalid_cin_please_enter_a_valid_cin')}`)
      .matches(
        /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
        `${translate('invalid_cin_please_enter_a_valid_cin')}`,
      )
      .trim(),

    'Driving Licence': Yup.string()
      .length(15, `${translate('length_must_be_15')}`)
      .matches(
        /^(([A-Z]{2}[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
        `${translate(
          'incorrect_driving_licence_please_enter_a_valid_driving_licence',
        )}`,
      )
      .trim(),

    Passport: Yup.string()
      .length(
        8,
        `${translate('incorrect_passport_please_enter_a_valid_passport')}`,
      )
      .trim(),

    'Voter ID': Yup.string()
      .length(10, `${translate('length_must_be_10')}`)
      .matches(
        /^[A-Z]{3}[0-9]{7}$/,
        `${translate('incorrect_voter_id_please_enter_a_valid_voter_id')}`,
      )
      .trim(),
  });
};

export default kycFormV2ValidationSchema;
